import { render, staticRenderFns } from "./OtherLabourSideMenu.vue?vue&type=template&id=0a46481b"
import script from "./OtherLabourSideMenu.vue?vue&type=script&lang=js"
export * from "./OtherLabourSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a46481b')) {
      api.createRecord('0a46481b', component.options)
    } else {
      api.reload('0a46481b', component.options)
    }
    module.hot.accept("./OtherLabourSideMenu.vue?vue&type=template&id=0a46481b", function () {
      api.rerender('0a46481b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/otherlabour/OtherLabourSideMenu.vue"
export default component.exports